import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79600af1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view-recordstop-top-box" }
const _hoisted_2 = {
  key: 0,
  class: "red-pack-info-box"
}
const _hoisted_3 = {
  key: 0,
  class: "red-pack-bl"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_greeting_card = _resolveComponent("greeting-card")!
  const _component_redpack_info_symbol = _resolveComponent("redpack-info-symbol")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_greeting_card, {
      skinImage: _ctx.skinImage,
      greetings: _ctx.redPackBasicInfo.title
    }, null, 8, ["skinImage", "greetings"]),
    _createVNode(_Transition, { name: "redpack-box" }, {
      default: _withCtx(() => [
        (_ctx.redPackBasicInfo.sender)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_redpack_info_symbol, {
                chainId: _ctx.redPackBasicInfo.chainId,
                info: _ctx.redPackBasicInfo
              }, null, 8, ["chainId", "info"]),
              (_ctx.isNoCreatorView)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_3, [
                    (_ctx.redPackBasicInfo.myReward)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" + " + _toDisplayString(_ctx.$tools.amountFormat(_ctx.redPackBasicInfo.myReward.amount, _ctx.redPackBasicInfo.myReward.decimal)) + " " + _toDisplayString(_ctx.redPackBasicInfo.myReward.denom), 1)
                        ], 64))
                      : (_ctx.redPackBasicInfo.status === 1)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.$checkI18n('receive.noMoreNotice')), 1)
                          ], 64))
                        : (_ctx.redPackBasicInfo.status === 2)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createTextVNode(_toDisplayString(_ctx.$checkI18n('receive.expiredNotice')), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}